__turbopack_context__.v({
  "cartPill": "SiteHeader-module-scss-module__-alWDa__cartPill",
  "group": "SiteHeader-module-scss-module__-alWDa__group",
  "nav": "SiteHeader-module-scss-module__-alWDa__nav",
  "navLink": "SiteHeader-module-scss-module__-alWDa__navLink",
  "navLinkActive": "SiteHeader-module-scss-module__-alWDa__navLinkActive",
  "navLinkIndicator": "SiteHeader-module-scss-module__-alWDa__navLinkIndicator",
  "navLinkIndicatorAnimated": "SiteHeader-module-scss-module__-alWDa__navLinkIndicatorAnimated",
  "navLinkIndicatorVisible": "SiteHeader-module-scss-module__-alWDa__navLinkIndicatorVisible",
  "navLinks": "SiteHeader-module-scss-module__-alWDa__navLinks",
  "navLinksWidthAnimated": "SiteHeader-module-scss-module__-alWDa__navLinksWidthAnimated",
});
